'use client';

import { AnimatedDiv, checkIsNative, cn, Div } from '@scatterlab/zeta-core';
import { FC, memo } from 'react';

import { Loading16Icon } from './icons';
import { SymbolWhite } from './logo';

export type LoadingAnimationProps = {
  loading: boolean;
  className?: string;
  showSymbol?: boolean;
  loaderClassName?: string;
  loaderBackgroundClassName?: string;
};

const LoadingAnimation: FC<LoadingAnimationProps> = ({
  loading,
  className,
  showSymbol = true,
  loaderClassName,
  loaderBackgroundClassName,
}) =>
  loading && (
    <Div
      key="loading-animation"
      className={cn(
        'native:absolute native:z-[60] native:size-full fixed inset-0 z-50 flex flex-1 flex-col items-center justify-center bg-black/70 backdrop-blur-[4px]',
        className,
      )}
    >
      <Div className="relative flex flex-col items-center justify-center">
        <AnimatedDiv
          className="relative"
          initial={{
            rotate: 0,
          }}
          animate={{
            rotate: 360,
          }}
          transition={
            checkIsNative()
              ? {
                  loop: true,
                  repeatReverse: false,
                  duration: 1000,
                  type: 'timing',
                }
              : {
                  duration: 1,
                  repeat: Infinity,
                }
          }
        >
          <Div className="absolute">
            <Loading16Icon
              className={cn(
                '-z-10 size-[83px] rotate-180 text-white/5',
                loaderBackgroundClassName,
              )}
            />
          </Div>
          <Loading16Icon
            className={cn('size-[83px] text-primary-400', loaderClassName)}
          />
        </AnimatedDiv>
        {showSymbol && (
          <Div className="absolute">
            <SymbolWhite className="size-6" />
          </Div>
        )}
      </Div>
    </Div>
  );

export default memo(LoadingAnimation);
